export default __webpack_public_path__ + "67ffcd8c8dca021639c897b182253e3f.woff";